import { TPAComponentProps } from '../../types';

export interface BadgeProps extends BadgeBaseProps {
  /**
   * This prop defines the style preset.
   * There are 4 different presets: ‘default’, ‘light’, ‘primary’ and ‘secondary’.
   * The default is ‘default’.
   */
  priority?: BadgePriority;
}

export interface BadgeDefaultProps {
  priority: BadgePriority;
}

export enum BadgePriority {
  default = 'default',
  light = 'light',
  primary = 'primary',
  secondary = 'secondary',
}

/** ******** Base component **********/
export interface BadgeBaseProps extends TPAComponentProps {
  icon?: React.ReactElement;
  children?: React.ReactNode;
}
/** *************************/
